import type { MessageDescriptor } from 'react-intl';

import BreakDownComplexIssuesDarkIcon from '../../../../assets/break-down-complex-issues-icon-dark-mode.svg';
import BreakDownComplexIssuesLightIcon from '../../../../assets/break-down-complex-issues-icon-light-mode.svg';
import CatchupAfterTimeAwayDarkIcon from '../../../../assets/catchup-after-time-away-icon-dark-mode.svg';
import CatchupAfterTimeAwayLightIcon from '../../../../assets/catchup-after-time-away-icon-light-mode.svg';
import CreateIssueDarkIcon from '../../../../assets/create-issue-icon-dark-mode.svg';
import CreateIssueLightIcon from '../../../../assets/create-issue-icon-light-mode.svg';
import DraftHelpfulCommentsOrUpdatesDarkIcon from '../../../../assets/draft-helpful-comments-or-updates-icon-dark-mode.svg';
import DraftHelpfulCommentsOrUpdatesLightIcon from '../../../../assets/draft-helpful-comments-or-updates-icon-light-mode.svg';
import MakeMyIssuesClearerDarkIcon from '../../../../assets/make-my-issues-clearer-icon-dark-mode.svg';
import MakeMyIssuesClearerLightIcon from '../../../../assets/make-my-issues-clearer-icon-light-mode.svg';
import ShareMyWorkWithStakeholdersDarkIcon from '../../../../assets/share-my-work-with-stakeholders-icon-dark-mode.svg';
import ShareMyWorkWithStakeholdersLightIcon from '../../../../assets/share-my-work-with-stakeholders-icon-light-mode.svg';

import { CONSUMER_STUBS, CREATOR_STUBS } from './messages';

export type PromptStubType = {
	message: MessageDescriptor;
	iconLight: string;
	iconDark: string;
	promptId: string;
};

export const CREATOR_PROMPTS: {
	message: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	iconLight: string;
	iconDark: string;
	promptId: string;
}[] = [
	{
		message: CREATOR_STUBS.createNewIssuesQuicklyStub,
		iconLight: CreateIssueLightIcon,
		iconDark: CreateIssueDarkIcon,
		promptId: 'createNewIssuesQuicklyPrompt',
	},
	{
		message: CREATOR_STUBS.breakDownComplexIssuesStub,
		iconLight: BreakDownComplexIssuesLightIcon,
		iconDark: BreakDownComplexIssuesDarkIcon,
		promptId: 'breakDownComplexIssuesPrompt',
	},
	{
		message: CREATOR_STUBS.makeMyIssuesClearerStub,
		iconLight: MakeMyIssuesClearerLightIcon,
		iconDark: MakeMyIssuesClearerDarkIcon,
		promptId: 'makeMyIssuesClearerPrompt',
	},
];

export const CONSUMER_PROMPTS: {
	message: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	iconLight: string;
	iconDark: string;
	promptId: string;
}[] = [
	{
		message: CONSUMER_STUBS.catchupAfterTimeAwayStub,
		iconLight: CatchupAfterTimeAwayLightIcon,
		iconDark: CatchupAfterTimeAwayDarkIcon,
		promptId: 'catchupAfterTimeAwayPrompt',
	},
	{
		message: CONSUMER_STUBS.draftHelpfulCommentsOrUpdatesStub,
		iconLight: DraftHelpfulCommentsOrUpdatesLightIcon,
		iconDark: DraftHelpfulCommentsOrUpdatesDarkIcon,
		promptId: 'draftHelpfulCommentsOrUpdatesPrompt',
	},
	{
		message: CONSUMER_STUBS.shareMyWorkWithStakeholdersStub,
		iconLight: ShareMyWorkWithStakeholdersLightIcon,
		iconDark: ShareMyWorkWithStakeholdersDarkIcon,
		promptId: 'shareMyWorkWithStakeholdersPrompt',
	},
];

export const CONFLUENCE_CONSUMER_PROMPTS: {
	message: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	iconLight: string;
	iconDark: string;
	promptId: string;
}[] = [
	{
		message: CONSUMER_STUBS.catchupAfterTimeAwayStub,
		iconLight: CatchupAfterTimeAwayLightIcon,
		iconDark: CatchupAfterTimeAwayDarkIcon,
		promptId: 'catchupAfterTimeAwayConfluencePrompt',
	},
	{
		message: CONSUMER_STUBS.draftHelpfulCommentsOrUpdatesStub,
		iconLight: DraftHelpfulCommentsOrUpdatesLightIcon,
		iconDark: DraftHelpfulCommentsOrUpdatesDarkIcon,
		promptId: 'draftHelpfulCommentsOrUpdatesConfluencePrompt',
	},
	{
		message: CONSUMER_STUBS.shareMyWorkWithStakeholdersStub,
		iconLight: ShareMyWorkWithStakeholdersLightIcon,
		iconDark: ShareMyWorkWithStakeholdersDarkIcon,
		promptId: 'shareMyWorkWithStakeholdersConfluencePrompt',
	},
];
